import * as React from 'react';

import styled from 'styled-components';

import ActionButton, { ActionButtonSizes, IActionButtonProps } from 'components/action-button';

export interface FabProps extends IActionButtonProps {
  caption: string;
}

const FabContainer = styled.div`
  position: fixed;
  bottom: 6rem;
  right: 1rem;
  z-index: 501;
`;

const StyledActionButton = styled(ActionButton)`
  background-color: ${Styles.color.black};
  font-size: 16px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

export const Fab: React.FC<FabProps> = ({ size = ActionButtonSizes.LARGE, caption, ...rest }) => (
  <FabContainer>
    <StyledActionButton size={size} {...rest}>
      {caption}
    </StyledActionButton>
  </FabContainer>
);
